import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TimeBasedRoutingApiService {

  private readonly timeBasedRoutingUrl: string = 'routing/condition/tbr';

  constructor(private http: HttpClient) {}

  public getTimeCondition(timeConditionId): Observable<any> {
    return this.http.get(`${this.timeBasedRoutingUrl}/${timeConditionId}`);
  }

  public getTimeConditions(): Observable<any> {
    return this.http.get(this.timeBasedRoutingUrl);
  }

  public deleteTimeCondition(timeConditionId): Observable<any> {
    return this.http.delete(`${this.timeBasedRoutingUrl}/${timeConditionId}`);
  }

  public addTimeCondition(timeCondition): Observable<any> {
    return this.http.post(this.timeBasedRoutingUrl, timeCondition);
  }

  public editTimeCondition(timeCondition, timeConditionId): Observable<any> {
    return this.http.put(`${this.timeBasedRoutingUrl}/${timeConditionId}`, timeCondition);
  }
}
